import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import TemplateEditor from "./TemplateEditor";

const TemplateEditorWrapper = () => {
  const { templateUuid } = useParams();

  const categoriesData = useMemo(() => {
    try {
      const data = localStorage.getItem("categoriesData");
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }, []);

  let htmlContent = "";
  for (const category of categoriesData) {
    const found = (category.templates || []).find(
      (tpl) => String(tpl.uuid) === String(templateUuid)
    );
    if (found) {
      htmlContent = found.html_content;
      break;
    }
  }

  return <TemplateEditor htmlContent={htmlContent} />;
};

export default TemplateEditorWrapper;